import React, { useState } from "react";
import { api } from "../lib/api";

export const EmailSignup = ({ sourceDetail = "footer", dark = false }) => {
  const [f, setF] = useState({ first_name: "", email: "", consent: false });
  const [state, setState] = useState({ busy: false, done: null, err: null });
  const fg = dark ? "var(--bg-cream)" : "var(--text-obsidian)";
  const submit = async (e) => {
    e.preventDefault();
    if (!f.consent) { setState({ busy: false, done: null, err: "Please tick the box to confirm you'd like to hear from us." }); return; }
    setState({ busy: true, done: null, err: null });
    try {
      const { data } = await api.post("/comms/signup", { ...f, source: "website", source_detail: sourceDetail });
      setState({ busy: false, done: data.message, err: null });
    } catch (x) { setState({ busy: false, done: null, err: x?.response?.data?.detail || "Something went wrong. Please try again." }); }
  };
  if (state.done) return <p data-testid="signup-confirmation" className="text-sm" style={{ color: dark ? "var(--gold-soft)" : "var(--burgundy)" }}>{state.done}</p>;
  return (
    <form onSubmit={submit} data-testid="email-signup-form" className="space-y-2">
      <div className="eyebrow mb-1" style={{ color: dark ? "var(--gold-soft)" : undefined }}>Stay connected</div>
      <p className="text-sm opacity-90 mb-3" style={{ color: fg }}>Receive new teachings, gatherings, writings, and updates from Temple of the Human Heart.</p>
      <input data-testid="signup-first-name-input" required placeholder="First name" value={f.first_name} onChange={(e) => setF({ ...f, first_name: e.target.value })}
        className="w-full rounded-lg border px-3 py-2 text-sm bg-transparent" style={{ borderColor: dark ? "rgba(247,240,227,0.25)" : "var(--border-cream)", color: fg }} />
      <input data-testid="signup-email-input" required type="email" placeholder="Email address" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })}
        className="w-full rounded-lg border px-3 py-2 text-sm bg-transparent" style={{ borderColor: dark ? "rgba(247,240,227,0.25)" : "var(--border-cream)", color: fg }} />
      <label className="flex items-start gap-2 text-xs opacity-90" style={{ color: fg }}>
        <input data-testid="signup-consent-checkbox" type="checkbox" checked={f.consent} onChange={(e) => setF({ ...f, consent: e.target.checked })} className="mt-0.5" />
        Yes, send me email from Temple of the Human Heart. I can unsubscribe at any time.
      </label>
      {state.err && <p data-testid="signup-error" className="text-xs" style={{ color: "var(--rose)" }}>{state.err}</p>}
      <button data-testid="signup-submit-btn" disabled={state.busy} className="rounded-full px-4 py-2 text-sm font-medium disabled:opacity-60" style={{ background: "var(--gold)", color: "var(--burgundy)" }}>
        {state.busy ? "…" : "Stay Connected"}
      </button>
    </form>
  );
};
